<div id="templates-and-forms-section">
    <h1>
        {{ 'dashboard.templatesAndForm.title' | translate }}
    </h1>

    <div class="templates-and-form-container">
        <div class="item-container">
            <span>
                {{ 'dashboard.templatesAndForm.csvOrderPlacementCsv' | translate }}
            </span>
            <p-button
                id="dashboard-download-csv-order-template"
                icon="fa-regular fa-file-csv"
                [ariaLabel]="'dashboard.templatesAndForm.csvOrderPlacementCsv.tooltip' | translate"
                [link]="true"
                [disabled]="isDownloadingTemplate()"
                [pTooltip]="'dashboard.templatesAndForm.csvOrderPlacementCsv.tooltip' | translate"
                [tooltipPosition]="'top'"
                (click)="downloadOrderTemplate()"></p-button>
        </div>

        <div class="item-container">
            <span>
                {{ 'dashboard.templatesAndForm.requestQuoteForCustomWork' | translate }}
            </span>
            <p-button
                id="dashboard-open-request-quote-for-custom-work-modal"
                icon="fa-regular fa-envelope"
                [ariaLabel]="'dashboard.templatesAndForm.requestQuoteForCustomWork.tooltip' | translate"
                [pTooltip]="'dashboard.templatesAndForm.requestQuoteForCustomWork.tooltip' | translate"
                [tooltipPosition]="'top'"
                [link]="true"
                (click)="toggleCustomWorkModal()"></p-button>
        </div>
    </div>
</div>

<app-request-quote-for-custom-work-modal
    [isVisible]="isCustomWorkModalVisible()"
    (isVisibleChange)="toggleCustomWorkModal()" />
